module.exports = __webpack_public_path__ + "static/media/building.8891a7d8.svg";